import { cn } from '@/lib/utils'
import { generateRandomColor } from '@/utils'
import { useState, type ComponentProps } from 'react'
import { FAIcon } from './fa-icon'

function generateColors(num: number, include: string) {
  return [
    include,
    ...Array(num)
      .fill('')
      .map(_ => generateRandomColor()),
  ]
}

interface Props extends Omit<ComponentProps<'div'>, 'onChange'> {
  value: string

  onChange: (value: string) => void
}

export function HoverColorPicker({
  className,

  value,

  onChange,

  ...props
}: Props) {
  const [colors, setColors] = useState(generateColors(7, value))

  return (
    <div className={cn('relative', className)} {...props}>
      <div
        className={cn('group size-7 rounded-sm')}
        style={{
          backgroundColor: value,
        }}
      >
        <div
          className={cn(
            'hidden absolute z-10 -top-1 -left-1 p-1 rounded-sm',
            'bg-white shadow-md',
            'group-hover:flex gap-1'
          )}
        >
          {colors.map(color => (
            <div
              key={color}
              className={cn(
                'size-7 rounded-sm cursor-pointer',
                value === color && 'ring-2'
              )}
              style={{
                backgroundColor: color,
              }}
              onClick={() => onChange(color)}
            />
          ))}

          <div
            className="flex items-center justify-center size-7 cursor-pointer hover:*:rotate-45"
            onClick={() => setColors(generateColors(7, value))}
          >
            <FAIcon className="transition-transform" icon="refresh" />
          </div>
        </div>
      </div>
    </div>
  )
}
